import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '../../atoms/RTCC/label';
import { InputText } from '../../atoms/RTCC/inputText';
import useMedia from 'use-media';
export const LabelInputForm = (props) => {


    const isWidePhone = useMedia({ maxWidth: '480px' });

    return (
        <div className={props.confirmText == null ? props.wrapClassName : props.labelWrap} >
            <Label label={props.label} className={props.labelClassName} />
            {props.confirmText == null ?
                <InputText
                    id={props.id}
                    type={props.type}
                    placeholder={props.placeholder}
                    maxLength={props.maxLength}
                    value={props.value}
                    onChange={props.onChange}
                    className={props.className}
                    max={props.max}
                    min={props.min}
                    tabIndex={props.tabIndex}
                /> :
                <Label label={props.confirmText} className="confirmLabelText" />
            }
        </div>
    );
}
